import { Produktlinienname } from '@ps20/bff-models';
import { Produktline, StatePreV9, StateV9 } from './9_migrate_versSummen.interface';

export const migrateProduktnameToEnumVersSummen = (
  previousState: StatePreV9,
  newVersion: number,
): StateV9 => {
  const versicherungssummen = previousState.versicherungssummen?.map(value => {
    return {
      ...value,
      produktlinie: mapToProduktname(value.produktlinie),
    };
  });
  const versicherungssummeFahrrad = previousState.versicherungssummeFahrrad?.map(value => {
    return {
      ...value,
      produktlinie: mapToProduktname(value.produktlinie),
    };
  });
  const wertsachensummen = previousState.wertsachensummen?.map(value => {
    return {
      ...value,
      produktline: mapToProduktname(value.produktline),
    };
  });
  return {
    ...previousState,
    version: newVersion,
    versicherungssummen,
    versicherungssummeFahrrad,
    wertsachensummen,
  };
};

function mapToProduktname(produktlinie: Produktline): Produktlinienname {
  let productName: Produktlinienname;
  switch (produktlinie) {
    case Produktline.S:
      productName = Produktlinienname.BASIS;
      break;
    case Produktline.M:
      productName = Produktlinienname.SMART;
      break;
    case Produktline.L:
      productName = Produktlinienname.KOMFORT;
      break;
    case Produktline.XL:
      productName = Produktlinienname.PREMIUM;
      break;
    default:
      productName = produktlinie as Produktlinienname;
      break;
  }
  return productName;
}
